import { Jodit } from "jodit-react";

/**
 * Template HTML para el formulario de enlaces en Jodit Editor
 * @param editor - Instancia del editor Jodit
 * @returns Template HTML del formulario de enlaces
 */
export const JODIT_LINK_TEMPLATE = (editor: Jodit): string => `
  <form class="jodit-ui-form" dir="auto">
    <div class="jodit-ui-block jodit-ui-block_align_left">
      <div class="jodit-ui-input jodit-ui-block__url">
        <span class="jodit-ui-input__label">URL</span>
        <div class="jodit-ui-input__wrapper">
          <input class="jodit-ui-input__input" dir="auto" name="url" type="text" data-ref="url_input" ref="url_input" required="true" placeholder="http://">
        </div>
      </div>
    </div>
    <div class="jodit-ui-block jodit-ui-block_align_left" data-ref="content_input_box" ref="content_input_box">
      <div class="jodit-ui-input jodit-ui-block__content">
        <span class="jodit-ui-input__label">Text</span>
        <div class="jodit-ui-input__wrapper">
          <input class="jodit-ui-input__input" dir="auto" name="content" type="text" data-ref="content_input" ref="content_input" placeholder="">
        </div>
      </div>
    </div>
    <input hidden checked class="jodit-ui-checkbox__input" dir="auto" name="target" type="checkbox" data-ref="target_checkbox" ref="target_checkbox" placeholder="" value="true">
    <div class="jodit-ui-block jodit-ui-block_align_right">
      <button class="jodit-ui-button jodit-ui-button_size_middle jodit-ui-button_unlink jodit-ui-button_variant_default jodit-ui-button_text-icons_true jodit-ui-block__unlink" type="button" role="button" aria-pressed="false" data-ref="unlink" ref="unlink">
        <span class="jodit-ui-button__icon"></span>
        <span class="jodit-ui-button__text">Unlink</span>
      </button>
      <button class="jodit-ui-button jodit-ui-button_size_middle jodit-ui-button_insert jodit-ui-button_variant_primary jodit-ui-button_text-icons_true jodit-ui-block__insert" type="submit" role="button" aria-pressed="false" data-ref="insert" ref="insert">
        Update
      </button>
    </div>
  </form>
`;
